module.exports = __webpack_public_path__ + "static/media/Tupe5.f3402a4c.webp";